module.exports = __webpack_public_path__ + "static/img/hk.ae2dec1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/flag/hk.jpg
// module id = h0ar
// module chunks = 0